import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { ChevronLeft, ChevronRight, Envelope, Phone } from 'react-bootstrap-icons';
import BackTitle from '../../component/BackTitle/BackTitle';
import ContainerFluid from '../../component/ContainerFluid';
import Header from '../../component/Header/Header';
import styles from './Contact.module.scss';
import {Formik, Form, Field, ErrorMessage} from 'formik';
import * as Yup from 'yup'
import Head from 'next/head';
import { useRouter } from 'next/router';
import {
  useGoogleReCaptcha
} from 'react-google-recaptcha-v3';
import contactLang from '../../i18n/contact'
import HtmlRender from '../../component/HtmlRender';
import ContactForm from './ContactForm';

const Contact = ({locale}) => {
  const {push} = useRouter()
  const formikRef = useRef()
  
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, height=device-height, initial-scale=1.0, user-scalable=0, minimum-scale=1.0, maximum-scale=1.0"/>
        <title>Contact us</title>
        <meta name="title" property="og:title" content="Contact with us"></meta>
        <meta property="description" content={
            locale === "vi"
            ? "Estuary sẽ phân tích tình hình và các vấn đề của doanh nghiệp bạn; từ đó đề xuất và phát triển các giải pháp phù hợp theo nhu cầu cụ thể của công ty bạn."
            : "Estuary listen to enterprise’s brief, contribute to bring clarity on business issues, propose concepts and develop them according to your specific needs."
          }
        ></meta>
        <meta name="description" property="og:description" content={
            locale === "vi"
            ? "Estuary sẽ phân tích tình hình và các vấn đề của doanh nghiệp bạn; từ đó đề xuất và phát triển các giải pháp phù hợp theo nhu cầu cụ thể của công ty bạn."
            : "Estuary listen to enterprise’s brief, contribute to bring clarity on business issues, propose concepts and develop them according to your specific needs."
          }
        ></meta>
        <meta property="og:image:alt" content={`banner`}></meta>
        <link rel="prefetch" href="/static/vn-flag.png" />
        <link rel="prefetch" href="/static/uk-flag.png" />
        <meta name="viewport" content="width=device-width, height=device-height, initial-scale=1.0, user-scalable=0, minimum-scale=1.0, maximum-scale=1.0"/>
        <meta name="image" property="og:image" content={`${process.env.NEXT_PUBLIC_MEDIA_FILE}f2b2acb7-e4a2-47cc-8f31-166caaaedf50`}></meta>
        <meta property="og:type" content="website"></meta>
        <meta property="og:url" content={locale ? `https://estuary.solutions/${locale}/contact` : `https://estuary.solutions/contact`}></meta>
        <link rel="canonical" href="https://estuary.solutions/contact" />
        {/* <link rel="shortcut icon" href={`https://iwsapi.vemedim.vn/vmd-iws-mediafile/file/a5ab3ee7-77a8-481d-8e03-65e7c95f9606`} type="image/x-icon" /> */}
        <link rel="shortcut icon" href={`${process.env.NEXT_PUBLIC_MEDIA_FILE}299c980f-d8d5-406e-8fe1-432221fa6896`} type="image/x-icon" />
        <meta name="keywords" content="Estuary Solutions" />
        <meta name="google-site-verification" content="6n3Wp03vZ36Noklv85xu6JvwOn7gCydfNscFhpoBDH0" />
      </Head>
      <ContainerFluid className={classNames("min-vh-100", styles.fullBackground)}>
        <Header />
        <div className="container">
          <BackTitle 
            title={contactLang.title[locale]}
            onClick={() => push("/")}
          />
          {/* <div className="d-flex align-items-center my-4">
            <div style={{paddingRight: "20px", marginLeft: "-38px"}} className="svg-wrapper">
              <ChevronLeft />
            </div>
            <h3 className="m-0 text-dark-blue md-text-size">Contact us</h3>
          </div> */}
        </div>
        <div className="container">
          <ContactForm
            ref={formikRef}
          >
            <div className="col-12 col-lg-12">
              <HtmlRender>
                {contactLang.paragraph[locale]}
              </HtmlRender>
              <p className="mb-0"><Envelope className="mr-2" /> <a href={`mailto: ${contactLang.email[locale]}`}>{contactLang.email[locale]}</a></p>
              <p><Phone className="mr-2" /> <a href={`tel: ${contactLang.phone[locale]}`} className="cursor-pointer text-dark-blue">{contactLang.phone[locale]}</a></p>
            </div>
          </ContactForm>
        </div>
      </ContainerFluid>
    </>
  );
};

export default Contact;